<template>
  <v-row align="center" justify="center" :class="is_mobile_screen ? 'flex-column-reverse' : ''">
    <div v-if="is_mobile_screen" class="mobile-space"></div>
    <v-col cols="12" md="5" class="pa-0 pl-2">
      <h2 class="mb-8 pl-2">
        {{language.color.main_title}}
      </h2>
      <v-chip
        v-for="color in colors"
        :key="color.hex"
        class="ma-2 pointer color-chip"
        :class="[selectedColor.name == color.name ? 'selected' : '', color.name == 'RAL 9016' ? 'dark' : '']"
        :color="color.hex"
        text-color="white"
        large
        :ripple="false"
        @click="changeColor(color)"
      >
        {{ color.name }}
      </v-chip>
    </v-col>
    <v-col cols="12" md="7" class="mt-md-12">
      <div class="d-flex flex-column flex-nowrap mt-md-12">
        <v-img
          class="mx-auto flex-shrink-1"
          max-width="100%"
          :src="require('../assets/img/color/'+imgLink)"
        ></v-img>
        <p class="caption mt-4 text-center">
          <v-icon>mdi-information</v-icon>
          <span class="middle ml-2">
            {{language.color.info_text}}
          </span>
        </p>
      </div>
    </v-col>
    <!-- <pre>{{imgLink}}</pre> -->
  </v-row>
</template>

<script>
export default {
  name: "Color",
  data: function () {
    return {
      selectedColor: {
        name: "RAL 7042",
        hex: "#A83C2B",
      },
    };
  },
  props: ["language", "colors", "img", "is_mobile_screen"],
  computed: {
    imgLink() {
      let color = this.selectedColor.name.substring(4);
      let name = this.img.substring(0, this.img.length - 5) + String(color);
      return name + ".png";
    },
  },
  methods: {
    changeColor(value) {
      this.selectedColor = value;
      this.$emit("changeColor", this.selectedColor);
    },
  },
};
</script>

<style lang="css"></style>
